import Modal from '../../../../../components/Modal';
import Button from '../../../../../components/Button';
import { Text, Actions } from './style';

export default function DeletePeriodModal({ isOpen, onClose, onDelete, isLoading }) {
  return (
    <Modal open={isOpen} toggle={onClose} title="Delete Reporting Period">
      <>
        <Text>Are you sure you want to delete this reporting period?</Text>

        <Actions>
          <Button size="sm" variant="unstyled" className="text-secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="sm"
            variant="unstyled"
            className="text-danger"
            onClick={onDelete}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Yes, Delete
          </Button>
        </Actions>
      </>
    </Modal>
  );
}
